import { useMemo } from 'react'
import { useSceneLineMarker } from '@editor/hooks'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { buildWallShapeOutlineLines } from '../../utils'

interface Props {
  /** the wall as currently edited in the form */
  wall: ShapeObject
  enabled: boolean
}

/** Marks the start (red) and end (blue) edge of the edited wall in 3D. */
const WallFormSceneMarker = ({ wall, enabled }: Props): null => {
  const { startEdgeLine, endEdgeLine } = useMemo(
    () =>
      buildWallShapeOutlineLines(
        wall.shape.points.map(point => new ImmutableVector3(point.x, point.y, point.z)),
      ),
    [wall],
  )

  useSceneLineMarker({
    lines: startEdgeLine ? [startEdgeLine] : [],
    enabled: enabled && startEdgeLine !== null,
    color: 'red',
    lineWidth: 5,
    renderOrder: 1000,
    disableDepthTest: true,
  })

  useSceneLineMarker({
    lines: endEdgeLine ? [endEdgeLine] : [],
    enabled: enabled && endEdgeLine !== null,
    color: 'blue',
    lineWidth: 5,
    renderOrder: 1000,
    disableDepthTest: true,
  })

  return null
}

export default WallFormSceneMarker
